import logoImg from "../../../assets/images/screenup-ai-white.svg";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import interviewAuthService from "../../../services/interviewAuthService";
import Header from "../../commonComponents/header/Header";

const Loader = () => {
  const toTitleCase = (name = "") => {
    return name
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("there");

  useEffect(() => {
    // Initialize the auth service and get user info
    interviewAuthService.initialize();

    // Get user email from JWT token
    const name = sessionStorage.getItem("candidateName");

    if (name) {
      setUserEmail(name);
    }

    setTimeout(() => {
      navigate("/camera"); // Changed from "/interview" to "/camera"
    }, 3000);
  }, [navigate]);

  return (
    <div className="h-screen w-screen bg-[#1F1F1F] box-border p-4 flex flex-col">
      <Header isWhite={true} />

      <div className="flex-1 flex flex-col items-center justify-center">
        {/* <div className="border-4 border-white border-t-transparent rounded-full w-12 h-12 animate-spin"></div> */}
        <div className="flex items-center justify-center">
          <div className="relative w-12 h-12 animate-spin-slow">
            {[...Array(12)].map((_, i) => (
              <span
                key={i}
                className="absolute left-1/2 top-1/2 block w-1 h-2.5 bg-white rounded animate-spinner-bar"
                style={{
                  transform: `rotate(${i * 30}deg) translate(0, -150%)`,
                  animationDelay: `${i * 0.1}s`,
                }}
              />
            ))}
          </div>
        </div>
        <h2 className="text-white app-title mt-4">
          Hello, {toTitleCase(userEmail)}!
        </h2>
        <p className="text-white app-body mt-2 text-center max-w-xl px-4">
          We are bringing up your ID Verification environment… Hold on.
        </p>
      </div>
    </div>
  );
};

export default Loader;
